import { cn } from "@repo/design-system/utils";
import type { ButtonHTMLAttributes } from "react";

/**
 * An inline text action in the drawer ("Try again", "Sign in", "Dismiss"): a
 * real `button` that reads as a link. The one place the interactive-foreground
 * link look is written, so the drawer's actions cannot drift apart.
 */
export function LinkButton({
  className,
  type = "button",
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type={type}
      className={cn(
        "text-ui-fg-interactive focus-visible:shadow-borders-focus flex w-fit items-center gap-x-1 rounded-sm text-sm font-medium underline-offset-2 hover:underline focus-visible:outline-none",
        className
      )}
      {...props}
    />
  );
}
